import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

export const BannerCircle1 = styled.div`
  position: absolute;
  bottom: -2rem;
  left: 5rem;
  width: 17.5rem;
  height: 17.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.60) 0%, rgba(129, 108, 255, 0.60) 100%);
  filter: blur(9.375rem);
  z-index: 1;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 10.625rem;
    height: 10.625rem;
    right: 2.75rem;
    left: unset;
    bottom: unset;
    top: 9.375rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(129, 108, 255, 0.40) 0%, rgba(129, 108, 255, 0.40) 100%);
    filter: blur(4.688rem);
  }
`;

export const BannerCircle2 = styled.div`
  position: absolute;
  bottom: -2rem;
  left: 14.375rem;
  width: 17.5rem;
  height: 17.5rem;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.50) 0%, rgba(100, 255, 227, 0.50) 100%);
  filter: blur(9.375rem);
  z-index: 2;
  // This code is to fix issues with the gradient in IOS
  transform: translateZ(0);
  backface-visibility: hidden;

  @media ${breakpoints.md} {
    width: 7.5rem;
    height: 7.5rem;
    right: -2.875rem;
    left: unset;
    bottom: unset;
    top: 15rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(100, 255, 227, 0.60) 0%, rgba(100, 255, 227, 0.60) 100%);
    filter: blur(5.625rem);
  }
`;

export const ContentWrapper = styled.div`
  & p, & ol, & ul, & dl {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  & h1, & h2,&  h3, & h4, & h5, & h6 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
`;
